import { DataTableRowV2Component, dataTableRowTemplate } from './DataTableRowV2';
import styles from './DataTableRowV2.styles.scss';
export const chameleonDataTableRowV2 = DataTableRowV2Component.compose({
    baseName: 'data-table-row-v2',
    template: dataTableRowTemplate,
    styles,
});
